// import { useContext, useEffect, useState } from "react";
// import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
// import Modal from "react-bootstrap/Modal";
// import { jsPDF } from "jspdf";
// import "jspdf-autotable";
// import * as XLSX from "xlsx";
// import "./AlarmLog2.css";
// import logo from '../../../../assets/img/logos/logo 2.png';
// import { AppThemeContext } from "../../../../context/AppThemeContext";
// import {
//     Box,
//     Card,
//     CssBaseline,
//     Grid,
//     Typography,
//     useTheme,
//     Stack
// } from '@mui/material';
// import { BusinessApi } from "../../../../api/Api";

// function AlaramLog2({ show, handleClose }) {
//     const { palette, spacing, shape: { borderRadius } } = useTheme();
//     const { PrimaryColor } = useContext(AppThemeContext);

//     const [logData, setLogData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [itemsPerPage] = useState(15);

//     const credentials = {
//         LOGIN_ID: localStorage.getItem("LOGIN_ID") || "",
//         SS_KEY: localStorage.getItem("SS_KEY") || "",
//     };

//     const fetchLogData = async () => {
//         setLoading(true);
//         setError(null);
//         setLogData([]);
//         try {
//             const res = await BusinessApi(credentials);
//             if (res?.data && Array.isArray(res.data)) {
//                 setLogData(res.data);
//             } else {
//                 setLogData([]);
//             }
//         } catch (err) {
//             setError("Failed to fetch data. Please try again.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchLogData();
//         const interval = setInterval(() => {
//             fetchLogData();
//         }, 30000); // every 30 seconds

//         return () => clearInterval(interval);
//     }, [credentials.LOGIN_ID]);

//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);
//     const totalPages = Math.ceil(logData.length / itemsPerPage);

//     const handlePageChange = (pageNumber) => {
//         setCurrentPage(pageNumber);
//     };

//     const tableHeaders = logData.length > 0 ? Object.keys(logData[0]) : [];

//     const exportToExcel = () => {
//         const ws = XLSX.utils.json_to_sheet(logData);
//         const wb = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(wb, ws, `AlarmLog`);
//         XLSX.writeFile(wb, `AlarmLog.xlsx`);
//     };

//     const exportToPDF = () => {
//         const doc = new jsPDF();
//         const imgWidth = 30;
//         const imgHeight = 20;
//         const xPos = (doc.internal.pageSize.width - imgWidth) / 2;
//         doc.addImage(logo, 'PNG', xPos, 10, imgWidth, imgHeight);
//         doc.setFontSize(12);
//         doc.text(`AlarmLog`, doc.internal.pageSize.width / 2, 35, { align: 'center' });

//         doc.autoTable({
//             head: [tableHeaders],
//             body: logData.map(item => tableHeaders.map(key => item[key])),
//             startY: 50,
//             theme: "grid",
//         });

//         doc.save(`AlarmLog.pdf`);
//     };

//     return (
//         <Modal show={show} onHide={handleClose} centered size="lg">
//             <Modal.Header closeButton className="modal-header-custom" style={{ backgroundColor: PrimaryColor }}>
//                 <Modal.Title>Alarm Log</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 <Grid container>
//                     <Grid item xs={12}>
//                         <Stack spacing={2}>
//                             <Card sx={{ padding: spacing(1), marginBottom: spacing(2) }}>
//                                 <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
//                                     <div style={{ fontSize: "14px", fontWeight: "bold", marginLeft: "7px" }}>
//                                         Alarm Log
//                                     </div>
//                                     <div style={{ display: "flex", gap: "10px" }}>
//                                         <button onClick={exportToExcel} className='export-button'>Excel</button>
//                                         <button onClick={exportToPDF} className='export-button2'>PDF</button>
//                                     </div>
//                                 </div>

//                                 {error && <div style={{ color: "red", marginBottom: "10px" }}>{error}</div>}

//                                 <div className="table-responsive">
//                                     <table className="table table-hover table-bordered">
//                                         <thead className="text-center" style={{ backgroundColor: "rgb(253, 248, 228)" }}>
//                                             <tr>
//                                                 <th>Sn</th>
//                                                 <th>User</th>
//                                                 <th>User Id</th>
//                                                 <th>Total Inverters</th>
//                                                 <th>Subscription Expiry Date</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {currentData.map((item, index) => (
//                                                 <tr key={index}>
//                                                     <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
//                                                     <td>{item.user || ""}</td>
//                                                     <td>{item.USER_ID || ""}</td>
//                                                     <td>{item.NOI || ""}</td>
//                                                     <td
//                                                 className={`text-center align-middle ${new Date(item.subscription_expiry_date) < new Date() ||
//                                                     new Date(item.subscription_expiry_date) <= new Date(new Date().setMonth(new Date().getMonth() + 1))
//                                                     ? "blink"
//                                                     : ""
//                                                     }`}
//                                                 style={{
//                                                     padding: "5px",
//                                                     fontSize: "12px",
//                                                     color:
//                                                         new Date(item.subscription_expiry_date) < new Date()
//                                                             ? "red" // Expired (Past)
//                                                             : new Date(item.subscription_expiry_date) <= new Date(new Date().setMonth(new Date().getMonth() + 1))
//                                                                 ? "orange" // Within Next Month
//                                                                 : "#333", // Future Dates
//                                                     whiteSpace: "nowrap",
//                                                 }}
//                                             >
//                                                 {item.subscription_expiry_date || ""}
//                                             </td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>

//                                 <div style={{ textAlign: "right", marginTop: "10px" }}>
//                                     <button
//                                         onClick={() => handlePageChange(currentPage - 1)}
//                                         disabled={currentPage === 1}
//                                         className='pagination-button'
//                                         style={{ color: PrimaryColor }}
//                                     >
//                                         Previous
//                                     </button>
//                                     {[...Array(totalPages)].map((_, index) => (
//                                         <button
//                                             key={index}
//                                             onClick={() => handlePageChange(index + 1)}
//                                             style={{
//                                                 backgroundColor: PrimaryColor,
//                                                 color: currentPage === index + 1 ? "#fff" : "#fff",
//                                             }}
//                                             className='pagination-button'
//                                         >
//                                             {index + 1}
//                                         </button>
//                                     ))}
//                                     <button
//                                         onClick={() => handlePageChange(currentPage + 1)}
//                                         disabled={currentPage === totalPages}
//                                         className='pagination-button'
//                                         style={{ color: PrimaryColor }}
//                                     >
//                                         Next
//                                     </button>
//                                 </div>
//                             </Card>
//                         </Stack>
//                     </Grid>
//                 </Grid>
//             </Modal.Body>
//         </Modal>
//     );
// }

// export default AlaramLog2;

import { useContext, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import "./AlarmLog2.css";
import logo from "../../../../assets/img/logos/logo 2.png";
import { AppThemeContext } from "../../../../context/AppThemeContext";
import { Card, Grid, useTheme, Stack } from "@mui/material";
import { BusinessApi } from "../../../../api/Api";

function AlaramLog2({ show, handleClose }) {
    const { spacing } = useTheme();
    const { PrimaryColor } = useContext(AppThemeContext);

    const [logData, setLogData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 15;

    const today = new Date();
    const oneMonthFromNow = new Date();
    oneMonthFromNow.setMonth(today.getMonth() + 1);

    // const credentials = {
    //     LOGIN_ID: localStorage.getItem("LOGIN_ID") || "",
    //     SS_KEY: localStorage.getItem("SS_KEY") || "",
    // };

    const credentials = {
        LOGIN_ID: localStorage.getItem("business_LOGIN_ID") || "",
        SS_KEY: localStorage.getItem("business_SS_KEY") || "",
    };

    useEffect(() => {
        (async () => {
            try {
                const res = await BusinessApi(credentials);
                setLogData(Array.isArray(res?.data) ? res.data : []);
            } catch {
                alert("Failed to fetch data.");
            }
        })();
    }, [credentials.LOGIN_ID]);

    const filteredData = logData.filter(({ subscription_expiry_date }) => {
        const expiry = new Date(subscription_expiry_date);
        return expiry <= oneMonthFromNow;
    });

    const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    const headers = ["Sn", "User", "User Id", "Plant Capacity", "Plant Location", "Total Inverters", "Plant Commissioned Date", "Subscription Expiry Date"];

    const mappedData = filteredData.map((item, index) => [
        index + 1,
        item.user || "",
        item.USER_ID || "",
        item.Plant_capacity || "",
        item.PLANT_LOCATION || "",
        item.NOI || "",
        item.PLANT_COMMISSIONED_DATE || "",
        item.subscription_expiry_date || ""
    ]);

    const exportToExcel = () => {
        const ws = XLSX.utils.aoa_to_sheet([headers, ...mappedData]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Web Portal Subscription Status");
        XLSX.writeFile(wb, "Web_Portal_Subscription_Status.xlsx");
    };

    const exportToPDF = () => {
        const doc = new jsPDF();
        doc.addImage(logo, "PNG", (doc.internal.pageSize.width - 30) / 2, 10, 30, 20);
        doc.setFontSize(12);
        doc.text("Web Portal Subscription Status", doc.internal.pageSize.width / 2, 35, { align: "center" });
        doc.autoTable({ head: [headers], body: mappedData, startY: 50, theme: "grid", styles: { fontSize: 8 } });
        doc.save("Web_Portal_Subscription_Status.pdf");
    };

    return (
        <Modal show={show} onHide={handleClose} centered size="xl">
            <Modal.Header closeButton className="modal-header-custom" style={{ backgroundColor: PrimaryColor }}>
                <Modal.Title>Web Portal Subscription Status</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Grid container>
                    <Grid item xs={12}>
                        <Stack spacing={2}>
                            <Card sx={{ p: spacing(1), mb: spacing(2) }}>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                                    <div style={{ fontSize: "14px", fontWeight: "bold", marginLeft: "7px" }}>Web Portal Subscription Status</div>
                                    <div style={{ display: "flex", gap: "10px" }}>
                                        <button onClick={exportToExcel} className="export-button">Excel</button>
                                        <button onClick={exportToPDF} className="export-button2">PDF</button>
                                    </div>
                                </div>

                                <div className="table-responsive">
                                    <table className="table table-hover table-bordered">
                                        <thead className="text-center" style={{ backgroundColor: "rgb(253, 248, 228)" }}>
                                            <tr>{headers.map((h, i) => <th key={i}>{h}</th>)}</tr>
                                        </thead>
                                        <tbody>
                                            {paginatedData.map((item, index) => {
                                                const expiry = new Date(item.subscription_expiry_date);
                                                const isExpired = expiry < today;
                                                const isExpiringSoon = expiry <= oneMonthFromNow;

                                                return (
                                                    <tr key={index}>
                                                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                                        <td>{item.user}</td>
                                                        <td>{item.USER_ID}</td>
                                                        <td>{item.Plant_capacity}</td>
                                                        <td>{item.PLANT_LOCATION}</td>
                                                        <td>{item.NOI}</td>
                                                        <td>{item.PLANT_COMMISSIONED_DATE}</td>
                                                        <td className={`text-center align-middle ${isExpired || isExpiringSoon ? "blink" : ""}`}
                                                            style={{
                                                                padding: "5px",
                                                                fontSize: "12px",
                                                                color: isExpired ? "red" : isExpiringSoon ? "orange" : "#333",
                                                                whiteSpace: "nowrap",
                                                            }}>
                                                            {item.subscription_expiry_date}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>

                                <div style={{ textAlign: "right", marginTop: "10px" }}>
                                    <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)} className="pagination-button" style={{ color: PrimaryColor }}>Previous</button>
                                    {[...Array(totalPages)].map((_, i) => (
                                        <button key={i} onClick={() => setCurrentPage(i + 1)} className="pagination-button" style={{ backgroundColor: PrimaryColor, color: "#fff" }}>{i + 1}</button>
                                    ))}
                                    <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(p => p + 1)} className="pagination-button" style={{ color: PrimaryColor }}>Next</button>
                                </div>
                            </Card>
                        </Stack>
                    </Grid>
                </Grid>
            </Modal.Body>
        </Modal>
    );
}

export default AlaramLog2;



